var _path, _path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgDocumentUpload(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 30,
    height: 30,
    viewBox: "0 0 30 30",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M25.625 12.7375H22.0125C19.05 12.7375 16.6375 10.325 16.6375 7.3625V3.75C16.6375 3.0625 16.075 2.5 15.3875 2.5H10.0875C6.2375 2.5 3.125 5 3.125 9.4625V20.5375C3.125 25 6.2375 27.5 10.0875 27.5H19.9125C23.7625 27.5 26.875 25 26.875 20.5375V13.9875C26.875 13.3 26.3125 12.7375 25.625 12.7375ZM14.4125 16.9125C14.225 17.1 13.9875 17.1875 13.75 17.1875C13.5125 17.1875 13.275 17.1 13.0875 16.9125L12.1875 16.0125V21.25C12.1875 21.7625 11.7625 22.1875 11.25 22.1875C10.7375 22.1875 10.3125 21.7625 10.3125 21.25V16.0125L9.4125 16.9125C9.05 17.275 8.45 17.275 8.0875 16.9125C7.725 16.55 7.725 15.95 8.0875 15.5875L10.5875 13.0875C10.675 13.0125 10.7625 12.95 10.8625 12.9C10.8875 12.8875 10.925 12.875 10.95 12.8625C11.025 12.8375 11.1 12.825 11.1875 12.8125C11.225 12.8125 11.25 12.8125 11.2875 12.8125C11.3875 12.8125 11.4875 12.8375 11.5875 12.875C11.6 12.875 11.6 12.875 11.6125 12.875C11.7125 12.9125 11.8125 12.9875 11.8875 13.0625C11.9 13.075 11.9125 13.075 11.9125 13.0875L14.4125 15.5875C14.775 15.95 14.775 16.55 14.4125 16.9125Z",
    fill: "#292D32"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M21.7876 11.0131C22.9751 11.0256 24.6251 11.0256 26.0376 11.0256C26.7501 11.0256 27.1251 10.1881 26.6251 9.6881C24.8251 7.8756 21.6001 4.6131 19.7501 2.7631C19.2376 2.2506 18.3501 2.6006 18.3501 3.3131V7.6756C18.3501 9.5006 19.9001 11.0131 21.7876 11.0131Z",
    fill: "#292D32"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgDocumentUpload);
export default __webpack_public_path__ + "static/media/document-upload.2889514f608e7ef2c0094fa6707bf7c4.svg";
export { ForwardRef as ReactComponent };